import React from 'react'
import styled from 'styled-components'
import DividerSection from './DividerSection'
import { shouldTranslateTo } from '../utils/utils'
import { Link } from 'react-router-dom'
import {
  ContainerFlexColumn,
  PrimaryButton,
  Subtitle,
  Title,
} from './Utils/CustomClasses'

const Container = styled.div`
  width: 100vw;
`

const ItAllStartsSection = styled.div`
  background-color: #f6f0e6;
  padding: 60px 8vw 60px 8vw;
  text-align: center;

  @media only screen and (max-width: 1280px) {
    padding: 60px 6vw 80px 6vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 60px 10vw 50px 10vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 72px 7vw 50px 7vw;
  }
`

const FullWidthButton = styled(PrimaryButton)`
  margin: 30px 0 0;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

const FullWidthButtonTwo = styled(FullWidthButton)`
  margin: 0 0 80px 0;
`

const SectionText = styled.div`
  text-align: left;

  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 0 auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const BulletListItemDiv = styled.div`
  line-height: 53px;
  margin: 0 0 50px 0;

  @media only screen and (max-width: 980px) {
    margin: 0 1vw 50px 0;
  }
`

const BulletListDot = styled.div`
  background-color: ${({ dotColor }) => (dotColor ? dotColor : '#fff')};
  border-radius: 50%;
  display: inline-block;
  width: 64px;
  height: 64px;
  text-align: center;
  vertical-align: top;
  line-height: normal;
`

const BulletListText = styled(Subtitle)`
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  margin: 0 0 0 20px;
  width: 80% !important;

  @media only screen and (max-width: 599px) {
    width: 60% !important;
  }
`

function SafetyTips() {
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()

    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('safety-tips', language)
  }, [])

  const BulletListItem = ({ dotColor, dotNumber, itemText }) => {
    return (
      <BulletListItemDiv>
        <BulletListDot dotColor={dotColor}>
          <Title
            color="#154549"
            margin="15px auto 15px auto"
            size="24px"
            sizemd="24px"
            sizesm="24px"
            dangerouslySetInnerHTML={{
              __html: `${dotNumber}`,
            }}
          />
        </BulletListDot>
        <BulletListText
          color="#154549"
          size="20px"
          sizemd="20px"
          sizesm="18px"
          dangerouslySetInnerHTML={{
            __html: `${itemText}`,
          }}
        />
      </BulletListItemDiv>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      {/* Header / Title */}
      <ContainerFlexColumn
        center
        padding="5vh 15vw 5vh 15vw"
        paddingSm="4vh 8vw 4vh 8vw"
        background="#fffbf4"
      >
        <Title
          center
          smCenter
          color="#154549"
          size="40px"
          sizemd="40px"
          sizesm="36px"
          margin="0 0 30px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[0]}` }}
        ></Title>
        <Subtitle
          center
          weight="400"
          color="#154549"
          size="26px"
          sizemd="26px"
          sizesm="20px"
          margin="0 0 24px 0"
          marginsm="0 8px 0 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[1]}`,
          }}
        />
      </ContainerFlexColumn>

      {/* Divider */}
      <DividerSection colorType={1.5} color={'#F6F0E6'} flip={true} />

      {/* It all starts... */}
      <ItAllStartsSection>
        <SectionText>
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={1}
            itemText={pageText[2]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={2}
            itemText={pageText[3]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={3}
            itemText={pageText[4]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={4}
            itemText={pageText[5]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={5}
            itemText={pageText[6]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={6}
            itemText={pageText[7]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={7}
            itemText={pageText[8]}
          />
          <BulletListItem
            dotColor="#FFFBF4"
            dotNumber={8}
            itemText={pageText[9]}
          />
        </SectionText>
        <Link to="/search?seeking=homestays">
          <FullWidthButton>
            <a>{pageText[13]}</a>
          </FullWidthButton>
        </Link>
      </ItAllStartsSection>

      {/* Divider */}
      <DividerSection colorType={5} color={'#f6f0e6'} flip={false} />

      {/* Become a Member */}
      <ContainerFlexColumn
        center
        padding="8vh 15vw 6vh 15vw"
        paddingSm="7vh 5vw 4vh 5vw"
        background="#154549"
      >
        <Title
          color="#FFFFFF"
          size="46px"
          sizemd="40px"
          sizesm="38px"
          center
          margin="0 10vw 40px 10vw"
          marginmd="0 10vw 40px 10vw"
          marginsm="20px 0 40px 0"
          dangerouslySetInnerHTML={{
            __html: `${pageText[10]}`,
          }}
        ></Title>
        <Subtitle
          center
          weight="300"
          color="#FFFFFF"
          size="22px"
          sizemd="22px"
          sizesm="22px"
          margin="0 7vw 50px 7vw"
          marginsm="0 8px 40px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[11]}`,
          }}
        />
        <Link to="/signup">
          <FullWidthButtonTwo>
            <a>{pageText[12]}</a>
          </FullWidthButtonTwo>
        </Link>
      </ContainerFlexColumn>
    </Container>
  )
}

export default SafetyTips
